import React from 'react'
import { Checkbox as MaterialCheckbox } from '@material-ui/core'
import { SUMMER_SKY } from 'constants/colors'
import {
  CheckboxCheckedIcon,
  CheckboxIcon,
  CheckboxContainer,
  IndeterminateIcon,
} from './Checkbox.styles'
import { CheckboxProps } from './Checkbox.types'

function Checkbox({
  checked,
  disabled = false,
  onChange,
  color = SUMMER_SKY,
  ...rest
}: CheckboxProps) {
  return (
    <CheckboxContainer color={color}>
      <MaterialCheckbox
        indeterminateIcon={<IndeterminateIcon />}
        checked={checked}
        checkedIcon={<CheckboxCheckedIcon color={color} />}
        icon={<CheckboxIcon />}
        onChange={onChange}
        aria-label="checkbox"
        disabled={disabled}
        {...rest}
      />
    </CheckboxContainer>
  )
}

export default Checkbox
